import React from 'react';
import cx from 'classnames';

import styles from './Footer.module.scss';

export const Footer: React.FC<
    React.PropsWithChildren<React.ComponentProps<'div'>> & {
        position?: 'start' | 'end' | 'middle';
        isPhone?: boolean;
    }
> = ({className, children, position = 'middle', isPhone = false, ...props}) => (
    <div
        className={cx(
            styles.footer,
            isPhone && styles.phone,
            styles[position],
            className,
        )}
        {...props}
    >
        {children}
    </div>
);
